module.exports = __webpack_public_path__ + "img/c05_unitmerchanttransport_Normal_ua.c7dba4dd.webp";